import { Link } from 'react-router-dom';
import { movies, movieCategories, getLatestMovies, getHotMovies } from '@/mocks/movies';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MovieCard from '@/components/base/MovieCard';

export default function Home() {
  const latestMovies = getLatestMovies();
  const hotMovies = getHotMovies();
  const featuredMovie = movies[0];

  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20scene%20with%20dramatic%20golden%20spotlight%20on%20red%20velvet%20curtain%2C%20warm%20golden%20and%20crimson%20atmosphere%2C%20luxurious%20classic%20cinema%20interior%2C%20empty%20stage%20with%20dramatic%20lighting%2C%20professional%20cinematic%20photography%2C%20rich%20textures%2C%20elegant%20composition&width=1600&height=900&seq=hero-cinema-bg&orientation=landscape"
            alt="天堂影院 - 高清电影在线看"
            title="天堂影院 高清电影在线看 免费电影网站"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/70"></div>

          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 text-center tracking-wide">
              天堂影院
            </h1>
            <p className="text-sm md:text-lg text-background-100/80 mb-8 text-center max-w-2xl leading-relaxed">
              高清电影在线看，免费电影网站汇聚最新电影在线观看、电影大全<br className="hidden sm:block" />
              高清不缓冲流畅在线观看，极速播放无广告，享受极致观影体验
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
              <Link
                to={'/movie/' + featuredMovie.id}
                className="px-6 py-3 md:px-8 md:py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-300 whitespace-nowrap text-sm md:text-base"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观看推荐影片
              </Link>
              <Link
                to="/category/scifi"
                className="px-6 py-3 md:px-8 md:py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-100/30 rounded-lg transition-all duration-300 whitespace-nowrap text-sm md:text-base"
              >
                浏览电影大全
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>

          <div className="absolute bottom-4 md:bottom-8 left-0 right-0 z-10 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-4 gap-2 md:gap-4">
                {[
                  { label: '高清画质', icon: 'ri-4k-line' },
                  { label: '极速播放', icon: 'ri-flashlight-line' },
                  { label: '海量片库', icon: 'ri-film-line' },
                  { label: '完全免费', icon: 'ri-vip-crown-line' },
                ].map((item) => (
                  <div key={item.label} className="flex items-center gap-2 bg-background-900/60 backdrop-blur-sm rounded-lg px-3 py-2 md:px-4 md:py-3">
                    <div className="w-7 h-7 md:w-8 md:h-8 rounded-md bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                      <i className={item.icon + ' text-primary-400 text-xs md:text-sm'}></i>
                    </div>
                    <span className="text-xs md:text-sm text-background-100/90 whitespace-nowrap">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                电影分类
              </h2>
              <p className="text-sm text-foreground-500">
                八大分类，精彩纷呈，发现你喜欢的电影类型
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
              {movieCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={'/category/' + cat.slug}
                  className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300"
                >
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-200 group-hover:bg-primary-100 flex items-center justify-center transition-colors duration-300">
                    <i className={cat.icon + ' text-xl md:text-2xl text-foreground-600 group-hover:text-primary-500 transition-colors duration-300'}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap transition-colors">
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-400">{cat.count}部</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Movies */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8 md:mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-1">
                  最新上映
                </h2>
                <p className="text-sm text-foreground-500">最新上线的热门影片</p>
              </div>
              <Link
                to="/category/action"
                className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors"
              >
                查看全部
                <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {latestMovies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          </div>
        </section>

        {/* Hot Movies */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8 md:mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-1">
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500">千万用户正在观看的热门影片</p>
              </div>
              <Link
                to="/category/drama"
                className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors"
              >
                查看全部
                <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {hotMovies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} size="small" />
              ))}
            </div>
          </div>
        </section>

        {/* Featured Movie Banner */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20movie%20scene%20collage%20with%20dragon%20and%20space%20and%20action%20elements%2C%20warm%20golden%20and%20crimson%20cinematic%20tones%2C%20dramatic%20lighting%2C%20professional%20film%20promotion%20banner%2C%20clean%20dark%20background%20with%20golden%20accents&width=1400&height=500&seq=featured-banner-01&orientation=landscape"
                alt="天堂影院 - 高清影视在线"
                title="天堂影院 高清影视在线 免费在线看大片"
                className="w-full h-[200px] md:h-[300px] object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>
              <div className="absolute inset-0 flex items-center px-6 md:px-12">
                <div className="max-w-md">
                  <h3 className="text-xl md:text-3xl font-heading text-background-50 mb-3">
                    高清不缓冲 · 极速播放
                  </h3>
                  <p className="text-sm md:text-base text-background-100/80 mb-5 leading-relaxed">
                    采用全球领先的CDN加速技术，无论您身在何处，都能享受流畅无卡顿的高清观影体验。1080P超清画质，杜比环绕音效，让每一帧都纤毫毕现。
                  </p>
                  <Link
                    to="/about"
                    className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-300 whitespace-nowrap text-sm"
                  >
                    了解更多
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* All Movies Grid */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                电影大全
              </h2>
              <p className="text-sm text-foreground-500">
                全部影片任你挑选，总有你喜欢的一部
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
              {movies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} size="small" />
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                为什么选择天堂影院
              </h2>
              <p className="text-sm text-foreground-500">
                六大优势，让你爱上在线观影
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  icon: 'ri-4k-fill',
                  title: '超清画质',
                  desc: '支持1080P蓝光画质，每一帧都清晰锐利，给你身临其境的观影体验，不亚于影院效果。',
                },
                {
                  icon: 'ri-speed-up-line',
                  title: '极速加载',
                  desc: '全球CDN节点加速，秒开不缓冲。无论电脑还是手机，点开就能流畅观看，告别漫长等待。',
                },
                {
                  icon: 'ri-shield-check-line',
                  title: '完全免费',
                  desc: '所有影片全部免费在线观看，无需注册，无需付费，无需会员，真正的免费电影网站。',
                },
                {
                  icon: 'ri-forbid-2-line',
                  title: '无广告打扰',
                  desc: '观影全程零广告，从片头到片尾一气呵成。不会被广告打断情绪，享受纯净的观影环境。',
                },
                {
                  icon: 'ri-global-line',
                  title: '海量片库',
                  desc: '涵盖动作、科幻、喜剧、剧情、恐怖、动画、纪录片、爱情等全部类型，片库每日更新。',
                },
                {
                  icon: 'ri-device-line',
                  title: '多端支持',
                  desc: '电脑端、平板端、手机端全面适配，随时随地想看在看。支持AirPlay投屏到大屏幕电视。',
                },
              ].map((feature) => (
                <div
                  key={feature.title}
                  className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200/50 transition-all duration-300"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
                    <i className={feature.icon + ' text-xl md:text-2xl text-primary-500'}></i>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
              开始你的观影之旅
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed">
              天堂影院汇聚高清电影在线看资源，提供最新电影在线观看、电影大全，高清不缓冲流畅在线观看，极速播放无广告。现在就加入我们，开启无限精彩的电影世界。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/scifi"
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-300 whitespace-nowrap text-sm"
              >
                立即观看热门影片
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-lg transition-all duration-300 whitespace-nowrap text-sm border border-background-200/60"
              >
                了解更多关于我们
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "天堂影院",
            url: "https://www.ttcinema.com",
            description: "天堂影院提供高清电影在线看，免费电影网站汇聚最新电影在线观看、电影大全，高清不缓冲流畅在线观看，极速播放无广告，享受极致观影体验。",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.ttcinema.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "天堂影院",
            url: "https://www.ttcinema.com",
            description: "天堂影院 - 高清电影在线看，免费电影网站，提供最新电影在线观看、电影大全。",
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "400-888-8888",
              contactType: "customer service",
              availableLanguage: "Chinese",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "光华路88号",
              addressLocality: "北京",
              addressRegion: "朝阳区",
              addressCountry: "CN",
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "天堂影院 - 首页",
            description: "天堂影院首页，高清电影在线看免费电影网站，最新电影在线观看、电影大全。",
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "首页",
                  item: "https://www.ttcinema.com",
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}